import { formatHistoryDate } from "../../history"
import { byNumber, byString } from "../../history/lib/sorters"
import { IHistory } from "../store/types/manyTargetCampaignsHistory"

const MANY_TARGETS_HISTORY_COLUMNS = [
  {
    title: "Campaign Name",
    key: "campaignName",
    render: (row: IHistory) => row.campaignName ?? "—",
    sorter: byString("campaignName"),
  },
  {
    title: "Target Name",
    key: "targetName",
    render: (row: IHistory) => row.targetName,
    sorter: byString("targetName"),
  },
  {
    title: "Bid Before",
    key: "oldBid",
    render: (row: IHistory) => `$${Number(row.oldBid).toFixed(2)}`,
    sorter: byNumber("oldBid"),
  },
  {
    title: "Bid After",
    key: "newBid",
    render: (row: IHistory) => `$${Number(row.newBid).toFixed(2)}`,
    sorter: byNumber("newBid"),
  },
  {
    title: "Placements Before",
    key: "placementsBefore",
    render: () => "—",
  },
  {
    title: "Placements After",
    key: "placementsAfter",
    render: () => "—",
  },
  {
    title: "Updated At",
    key: "createdAt",
    render: (row: IHistory) => formatHistoryDate(row.createdAt),
    sorter: byString("createdAt"),
  },
]

const useColumns = () => MANY_TARGETS_HISTORY_COLUMNS

export default useColumns
